"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeVue = void 0;
const utils_1 = require("./utils");
const core_1 = require("../core");
const featureFlags_1 = require("../featureFlags");
function initializedReactiveStore() {
    const vue = (0, utils_1.loadVue)();
    if ((0, utils_1.isVue3)(vue)) {
        (0, featureFlags_1.setReactiveStore)(vue.reactive({ data: {} }));
    }
    else {
        (0, featureFlags_1.setReactiveStore)(vue.observable({ data: {} }));
    }
}
initializedReactiveStore();
async function initializeVue(key, user, options) {
    const client = await (0, core_1.initialize)(key, user, options);
    (0, featureFlags_1.setFeatureFlags)(client.allFlags());
    client.on('change', () => {
        (0, featureFlags_1.setFeatureFlags)(client.allFlags());
    });
}
exports.initializeVue = initializeVue;
